import React, { useState, useEffect } from "react";
import { getFirestore, doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import Menu from "./Menu.js";
import Curriculum from "./Curriculum.js";
import ConfigCV from "./ConfigCV.js";
import MensajesOP from "./MensajesOP.js";
import SentRequests from './SentRequests.js';
import Loading from "./Loading.js";
import "./PostulanteOffice.css";
import {FaCog,} from "react-icons/fa";

const PostulanteOffice = () => {
  const auth = getAuth();
  const db = getFirestore();
  const navigate = useNavigate();

  const [profileData, setProfileData] = useState({
    uid: "",
    videos: [],
    skills: "",
    experience: "",
    salary: "",
    jobExpectations: "",
  });
  const [loading, setLoading] = useState(true);
  const [activeSection, setActiveSection] = useState("config");

  useEffect(() => {
    const fetchData = async () => {
      const user = auth.currentUser;

      if (!user) {
        alert("Por favor, inicia sesión para continuar.");
        navigate("/login");
        return;
      }

      try {
        const userRef = doc(db, "postulantes", user.uid); // Colección "postulantes"
        const userSnap = await getDoc(userRef);

        if (userSnap.exists()) {
          setProfileData({ ...userSnap.data(), uid: user.uid });
        } else {
          const newProfileData = {
            uid: user.uid,
            videos: [],
            skills: "",
            experience: "",
            salary: "",
            jobExpectations: "",
          };
          await setDoc(userRef, newProfileData);
          setProfileData(newProfileData);
        }
      } catch (error) {
        console.error("Error al cargar los datos del perfil:", error);
        alert("Hubo un problema al cargar tu perfil.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [auth, db, navigate]);


  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  if (loading) {
    return <div><Loading /></div>;
  }

  return (
    <div className="vp-container">
      <Menu />
      <div className="vp-main-content">
        <div className="user-office">
          <nav className="office-menu">
          <button
              className={activeSection === 'requests' ? 'active' : ''}
              onClick={() => handleSectionChange('requests')}
            >
              Solicitudes
            </button>
            <button
              className={activeSection === "cv" ? "active" : ""}
              onClick={() => handleSectionChange("cv")}
            >
              Mi CV
            </button>
            <button
              className={activeSection === "messages" ? "active" : ""}
              onClick={() => handleSectionChange("messages")}
            >
               <i className={`fa-solid ${activeSection === "messages" ? "fa-envelope-open-text" : "fa-envelope"}`}></i>
            </button>
            <button
              className={activeSection === "config" ? "active" : ""}
              onClick={() => handleSectionChange("config")}
            >
              <span><FaCog /></span>
            </button>
          </nav>
          <div className="office-content">
            {activeSection === "config" && (
              <ConfigCV
                profileData={profileData}
                setProfileData={setProfileData}
              />
            )}
            {activeSection === 'requests' && <SentRequests />}
            {activeSection === "cv" && <Curriculum profileData={profileData} />}
            {activeSection === "messages" && <MensajesOP />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostulanteOffice;
